import React from "react";
import { ProviderProps } from "../common/types";
import { AppProvider } from "./app/context";
import { ThemeProvider } from "./theme/context";

export const RobinProvider: React.FC<ProviderProps> = (
  props: ProviderProps
) => {
  return (
    <AppProvider>
      <ThemeProvider>{props.children}</ThemeProvider>
    </AppProvider>
  );
};
